// extracted by mini-css-extract-plugin
export default {"message":"Message_message__o40Lp","error":"Message_error__z9dY4"};